import * as React from "react";
import Login from "./public-sign-in/Login";
import Csrf from "./commons/model/Csrf";
import { createRoot } from "react-dom/client";

export interface SignInProps {
  loginErrorMessages?: string;
  loginNameError?: boolean;
  loginDateError?: boolean;
  contactUsEmail: string;
  csrf: Csrf;
}

export default function PublicSignIn({
  loginErrorMessages,
  csrf,
  loginNameError,
  loginDateError,
}: SignInProps) {
  return (
    <Login
      errorMessages={loginErrorMessages ? loginErrorMessages.split(",") : []}
      csrf={csrf}
      loginNameError={loginNameError}
      loginDateError={loginDateError}
    />
  );
}

PublicSignIn.loadComponent = (elementId: string, props: SignInProps) => {
  const container = document.getElementById(elementId);
  const root = createRoot(container!);
  root.render(<PublicSignIn {...props} />);
};
